export default __webpack_public_path__ + "bf08c5cfe39b545077836c072f89d1d1.png";